import React from "react";

function getMainMaxWidth() {
  return 500;
}

export default getMainMaxWidth;
